import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ChevronDown, ChevronUp } from 'lucide-react'
import { ProjectCardV2 } from './project-card-v2'
import type { TeamWithActions } from '@/shared/types'

interface CompletedSectionProps {
  teams: TeamWithActions[]
}

const INITIAL_DISPLAY_COUNT = 3

export function CompletedSection({ teams }: CompletedSectionProps) {
  const { t } = useTranslation()
  const [showAll, setShowAll] = useState(false)

  if (teams.length === 0) return null

  const hasMore = teams.length > INITIAL_DISPLAY_COUNT
  const displayedTeams = showAll ? teams : teams.slice(0, INITIAL_DISPLAY_COUNT)

  return (
    <section className="flex flex-col gap-4">
      {/* Section header */}
      <h2 className="text-lg font-semibold text-foreground">
        {t('dashboard.sections.completed', { count: teams.length })}
      </h2>

      {/* Cards grid */}
      <div className="grid grid-cols-1 gap-6 md:grid-cols-2 xl:grid-cols-3">
        {displayedTeams.map((team) => (
          <ProjectCardV2 key={team.id} team={team} variant="completed" />
        ))}
      </div>

      {/* View all / Show less toggle */}
      {hasMore && (
        <button
          onClick={() => setShowAll(!showAll)}
          className="flex items-center gap-1.5 self-start text-sm font-medium text-accent transition-colors hover:text-accent-hover"
        >
          {showAll ? (
            <>
              {t('dashboard.sections.showLess')}
              <ChevronUp className="h-4 w-4" />
            </>
          ) : (
            <>
              {t('dashboard.sections.viewAll', { count: teams.length })}
              <ChevronDown className="h-4 w-4" />
            </>
          )}
        </button>
      )}
    </section>
  )
}
